import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { Observable, ReplaySubject } from 'rxjs';
import { ResponseData } from 'src/app/Model/Base/Response';
import { RequestModel } from 'src/app/Model/Request.model';
import { RequestStatusAgencyPolicyViewModel } from 'src/app/Model/RequestStatusAgencyPolicyView.model';
import { SessionStorageService } from 'src/app/Services/sessionStorageService/session-storage.service';
import { RequestService } from 'src/app/Services/request/request.service';
import { RequesStatusService } from 'src/app/Services/RequestStatus/RequesStatus.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-agency-policy',
  templateUrl: './agency-policy.component.html',
  styleUrls: ['./agency-policy.component.css']
})
export class AgencyPolicyComponent implements OnInit {
  file: File;
  idRequest;
  request: RequestModel
  async ngOnInit() {
    await this.loadRequest()
  }
  async loadRequest() {
    await this.spinner.show()
    this.idRequest = this.lsService.getLSItem("IdRequest")
    let rq = await this.requestService.getRequestById(this.idRequest);
    if (rq != null) {
      this.request = rq;
      this.lsService.setLSItem("RequestCode",rq.RequestCode)
      await this.spinner.hide()
    }
    else {
      await this.spinner.hide()
      await Swal.fire({
        title: 'Error!',
        text: this.translate.instant('ExtraWarranty.Message.Error'),
        icon: 'error'
      }
      )

    }
  }

  constructor(
    private readonly spinner: NgxSpinnerService,
    private readonly RequestStatus: RequesStatusService,
    private readonly translate: TranslateService,
    private readonly requestService: RequestService,
    private readonly activatedRoute: ActivatedRoute,
    private readonly lsService : SessionStorageService) {
    this.activatedRoute.queryParams.subscribe(params => {
      if (params.id!=null){
        this.idRequest = params.id
        this.lsService.setLSItem("IdRequest",params.id)
      }
    });
  }

  async onFileSelected(event) {
    this.file=null;
    await this.spinner.show();
    let size =event.target.files[0].size;
    if(size>2097152)
    {
      this.resetFile();
      await this.spinner.hide();
      await Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: this.translate.instant('ExtraWarranty.Message.Size')
      })
      return;
    }
    let type =event.target.files[0].type;
    if (type != 'application/pdf') {
      this.resetFile();
      await this.spinner.hide();
      await Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: this.translate.instant('ExtraWarranty.Message.Extension')
      })
      return;
    }
    this.file = event.target.files[0];
    await this.spinner.hide();
    


  }
  async uploadFile() {
    this.convertFile(this.file).subscribe(async base64 => {
      this.spinner.show();
      let res: ResponseData;
      let status = new RequestStatusAgencyPolicyViewModel();
      status.File = base64;
      status.IdRequest = this.request.Id;
      status.IdProfile = null;
      status.Approve = true;
      status.IdComponent = 15
      await this.RequestStatus.SetStatusAgencyPolicy(status).then(resp => {
        res = resp;
      })
      await this.spinner.hide();
      if (res.head.status.toLowerCase() == 'true') {
        await this.loadRequest()
        await Swal.fire({
          icon: 'success',
          text: this.translate.instant('Request.Messages.Success'),
          showConfirmButton: false,
          timer: 2000
        })
      }
      else {
        await Swal.fire({
          title: 'Error!',
          text: res.head.error.description,
          icon: 'error'
        }
        )
      }
    });
  }
  convertFile(file: File): Observable<string> {

    const result = new ReplaySubject<string>(1);
    const reader = new FileReader();
    reader.readAsBinaryString(file);
    reader.onload = (event) => result.next(btoa(event.target.result.toString()));

    return result;
  }

  resetFile() {
    (<HTMLInputElement>document.getElementById('fileUpload')).value = "";
  }
}
